import { action, observable } from "mobx";
import NestStore from "~/stores/NestStore";
import UiMeet3dPhotoRepository from "~/repository/UiMeet3d/UiMeet3dPhotoRepository";
import UiMeet3dPhoto from "~/models/UiMeet3d/UiMeet3dPhoto";

class UiMeet3dPhotoStore extends NestStore {
  /**
   * @property {Array}
   */
  @observable uiMeet3dPhotos = [];

  /**
   * @property {UiMeet3dPhoto}
   */
  @observable uiMeet3dPhoto = new UiMeet3dPhoto();

  /**
   * @property {number|null}
   */
  uiMeet3dPhotoId = null;

  uiMeet3dPhotoRepository = null;

  constructor() {
    super();

    this.uiMeet3dPhotoRepository = new UiMeet3dPhotoRepository();

    this.setDefaultSearchParams();
  }

  @action
  loadIndex() {
    this.isLoading = true;

    return Promise.all([this.getAll()]).finally(() => {
      this.isLoading = false;
    });
  }

  /**
   * Get all.
   */
  @action
  getAll() {
    const params = {
      offset: this.offset,
      limit: this.pagination.itemsPerPage,
    };

    if (this.searchParams.providerId !== "") {
      params.providerId = this.searchParams.providerId;
    }

    if (this.searchParams.customerId !== "") {
      params.customerId = this.searchParams.customerId;
    }

    return this.uiMeet3dPhotoRepository.fetch(params).then(response => {
      this.processEntities(response.data.uiMeet3dPhotos);
      this.processPagination(response.data.pagination);
    });
  }

  @action
  processEntities(uiMeet3dPhotos = []) {
    this.uiMeet3dPhotos = [];

    uiMeet3dPhotos.forEach(uiMeet3dPhotoArray => {
      const uiMeet3dPhoto = new UiMeet3dPhoto(uiMeet3dPhotoArray);

      this.uiMeet3dPhotos.push(uiMeet3dPhoto);
    });
  }

  /**
   * Change the pagination page and fetch the Ui Meet3d Photos.
   */
  @action
  changePage(page) {
    this.pagination.currentPage = page;

    return this.loadIndex();
  }

  /**
   * Change the pagination page and fetch the Ui Meet3d Photos.
   */
  @action
  search() {
    this.pagination.currentPage = 1;

    return this.loadIndex();
  }

  @action
  create(data) {
    this.isSaving = true;

    return this.uiMeet3dPhotoRepository
      .create(data)
      .then(response => {
        this.uiMeet3dPhoto = new UiMeet3dPhoto(response.data.uiMeet3dPhoto);
        this.isSaving = false;
      })
      .catch(e => {
        this.isSaving = false;
        this.setErrorMessages(e);
        throw e;
      });
  }

  /**
   * Set default search params.
   */
  @action
  setDefaultSearchParams() {
    this.searchParams.providerId = "";
    this.searchParams.customerId = "";
  }

  @action
  delete(uiMeet3dPhoto) {
    this.isSaving = true;

    return this.uiMeet3dPhotoRepository
      .delete(uiMeet3dPhoto)
      .catch(e => {
        this.isSaving = false;
        this.setErrorMessages(e);
        throw e;
      })
      .finally(() => {
        this.isSaving = false;
      });
  }

  getUiMeet3dPhotoByType(uiMeet3dPhotos, type) {
    const uiMeet3dPhoto = uiMeet3dPhotos.find(item => item.type === type);

    return typeof uiMeet3dPhoto !== "undefined" ? uiMeet3dPhoto : null;
  }

  getUiMeet3dPhotoPathWeb(uiMeet3dPhotos, type) {
    const uiMeet3dPhoto = this.getUiMeet3dPhotoByType(uiMeet3dPhotos, type);

    return uiMeet3dPhoto && uiMeet3dPhoto.photoUrl ? uiMeet3dPhoto.photoPathWeb : null;
  }

  canDeleteUiMeet3dPhoto(uiMeet3dPhotos, type) {
    const uiMeet3dPhoto = this.getUiMeet3dPhotoByType(uiMeet3dPhotos, type);

    return uiMeet3dPhoto !== null;
  }
}

export default UiMeet3dPhotoStore;
